export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-950 text-foreground-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <a
              href="#hero"
              onClick={(e) => { e.preventDefault(); scrollTo('#hero'); }}
              className="inline-flex items-center gap-2 mb-4 cursor-pointer"
            >
              <span className="text-xl font-bold text-primary-400 font-heading tracking-tight">
                99<span className="text-white">视频</span>
              </span>
            </a>
            <p className="text-foreground-400 text-xs leading-relaxed mb-4">
              聚合香蕉视频、红桃视频、91视频、蜜桃视频等热门视频平台，提供高清免费在线观看服务。海量影视资源一站式收录，不缓冲流畅播放。
            </p>
            <div className="flex items-center gap-3">
              <a href="#contact" onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }} className="w-8 h-8 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500/40 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-foreground-300 text-sm"></i>
              </a>
              <a href="#contact" onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }} className="w-8 h-8 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500/40 transition-colors cursor-pointer">
                <i className="ri-mail-line text-foreground-300 text-sm"></i>
              </a>
              <a href="#contact" onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }} className="w-8 h-8 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500/40 transition-colors cursor-pointer">
                <i className="ri-send-plane-line text-foreground-300 text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-white font-semibold text-sm mb-4">快速导航</h3>
            <nav className="flex flex-col gap-2.5">
              {[
                { label: '最新动态', href: '#updates' },
                { label: '热门榜单', href: '#ranking' },
                { label: '平台特色', href: '#features' },
                { label: '热门话题', href: '#topics' },
                { label: '精彩推荐', href: '#media' },
                { label: '内容索引', href: '#index' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => { e.preventDefault(); scrollTo(item.href); }}
                  className="text-foreground-400 hover:text-primary-400 text-xs transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h3 className="text-white font-semibold text-sm mb-4">聚合平台</h3>
            <nav className="flex flex-col gap-2.5">
              {[
                { label: '香蕉视频', href: '#cards' },
                { label: '红桃视频', href: '#cards' },
                { label: '91视频', href: '#cards' },
                { label: '蜜桃视频', href: '#cards' },
                { label: '高清影院', href: '#cards' },
                { label: '动漫专区', href: '#cards' },
              ].map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  onClick={(e) => { e.preventDefault(); scrollTo(item.href); }}
                  className="text-foreground-400 hover:text-primary-400 text-xs transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h3 className="text-white font-semibold text-sm mb-4">合作伙伴</h3>
            <div className="flex flex-col gap-2.5">
              <p className="text-foreground-500 text-xs">更多合作伙伴即将入驻</p>
              <p className="text-foreground-500 text-xs">敬请期待</p>
            </div>
            <h3 className="text-white font-semibold text-sm mt-6 mb-3">移动端下载</h3>
            <div className="flex items-center gap-2">
              <a
                href="#app"
                onClick={(e) => { e.preventDefault(); scrollTo('#app'); }}
                className="flex items-center gap-1.5 px-3 py-2 rounded-lg bg-foreground-800 hover:bg-foreground-700 text-foreground-300 text-xs transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-android-line"></i> Android
              </a>
              <a
                href="#app"
                onClick={(e) => { e.preventDefault(); scrollTo('#app'); }}
                className="flex items-center gap-1.5 px-3 py-2 rounded-lg bg-foreground-800 hover:bg-foreground-700 text-foreground-300 text-xs transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-apple-line"></i> iOS
              </a>
            </div>
          </div>
        </div>

        <div className="pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; 2024-2026 99视频 版权所有 | 聚合香蕉视频、红桃视频、91视频、蜜桃视频热门视频平台
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#faq" onClick={(e) => { e.preventDefault(); scrollTo('#faq'); }} className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
              常见问题
            </a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }} className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
              联系我们
            </a>
            <a href="#about" onClick={(e) => { e.preventDefault(); scrollTo('#about'); }} className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
              关于我们
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}